import React, { useEffect, useState, ChangeEvent, useContext } from 'react';
import { API } from 'aws-amplify';
import { getAPIName } from '../../config';
import { StatusOption } from '../TopForm';
import handleApiErrors from '../../common/handleApiErrors';
import ReactTable, { Column, SortingRule } from 'react-table';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import AutocompleteSelect from '../common/AutocompleteSelect';
import { generateMailHref } from '../../common/helper';
import ConfirmationModal from '../helpercomponent/confirmationModal'
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import {
    Button,
    Divider,
    Grid,
    Typography,
    CircularProgress,
    TextField,
    Tooltip
} from '@material-ui/core';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import useCustomSnak from '../helpers/handleSnackbars';
import DateRangePicker from '../date-range-picker.component';
import TopFormSearch, { TopFormSearchOption } from '../TopFormSearch';
import EditInvoicePopup from '../EditInvoicePopup'
import { SubscriptionInvoice } from '../../_models/SubscriptionInvoice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPencilAlt,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Auth } from "aws-amplify";
import { PaymentDetails } from '../PaymentDetails';
import { PAYMENT_LOGOS } from '../../common/utils';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { AmplifyAuthContext } from "../../App";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: 200
        },
        dense: {
            marginTop: theme.spacing(2),
        },
        menu: {
            width: 200,
        },
        button: {
            marginLeft: theme.spacing(0),
            marginRight: theme.spacing(1),
            marginTop: theme.spacing(5),
            width: 100
        },
        paymentlink_reactivation :{
            background: "forestgreen",
            color: "white",
            '&:hover': { 
              backgroundColor: 'darkgreen',
            },
          },
    }),
);


const statusOptionsDict: any = {
    "Charged": "Charged",
    "Created": "Created",
    "Declined": "Declined",
    "missing_cc_token": "Missing Credit Card",
    "manually_charged": "Manually Charged",
    "customer_dispute_won": "Customer Dispute - Won",
    "customer_dispute_lost": "Customer Dispute - Lost",
    "customer_dispute_initiated": "Customer Dispute - Initiated",
    "manually_refunded": "Manually Refunded",
    "integrated_invoice_sent": "Created",
    "partially_charged":"Partially Charged"
}
const paymentlinkStatusOptions: any = {
    "Complete": "Charged",
    "Created": "Created",
    "Declined": "Declined",
    "Expired": "Expired"
}
interface PendingUpdate {
  invoice: any;
  updated_status: string;
}

interface PageState {
    readonly page: number;
    readonly pageSize: number;
    readonly sortingRules: SortingRule[];
}
const searchOptions: TopFormSearchOption[] = [
  { label: 'Invoice No', value: 'id' },
  { label: 'Email', value: 'customer-email' },
];
interface TopFormState {
    readonly dealershipId: number;
    readonly statusSelection?: StatusOption;
    searchInput: string,
    searchType: TopFormSearchOption,
}
interface SearchState {
    readonly firstName: string;
    readonly lastName: string;
    readonly startDate?: Date;
    readonly endDate?: Date;
}

const defaultSearchState: SearchState = {
    firstName: '',
    lastName: '',
    startDate: undefined,
    endDate: undefined
};
const defaultPageState: PageState = {
    page: 0,
    pageSize: 10,
    sortingRules: [{
        id: 'id',
        desc: true,
    }],
};

export default function SubscriptionInvoices() {
    const classes = useStyles();
    const handleCustomSnak = useCustomSnak();
    const { enqueueSnackbar } = useSnackbar();
    const currentAuthenticatedUser: any = useContext(AmplifyAuthContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pageState, setPageState] = useState<PageState>(defaultPageState);
    const [topFormState, setTopFormState] = useState<TopFormState>({
        dealershipId: 0,
        statusSelection: undefined,
        searchInput: '',
        searchType: searchOptions[0]
    });
    const [reloadData, setreloadData] = useState(false)
    const [filterState, setFilterSetState] = React.useState<SearchState>(defaultSearchState);
    const [editInvoiceStatFlag, setEditInvoiceStatFlag] = useState(false)
    const [invoiceToEdit, setInvoiceToEdit] = useState({})
    const [updatedInvoiceStatus, setUpdatedInvoiceStatus] = useState('')
    const [updateExecuted, setUpdateExecuted] = useState(false)
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [pendingInvoiceUpdate, setPendingInvoiceUpdate] = useState<PendingUpdate | null>(null);
    const userRole: string = currentAuthenticatedUser == null ||
      currentAuthenticatedUser.attributes == null ||
      currentAuthenticatedUser.attributes.given_name == null
      ? 'Individual'
      : currentAuthenticatedUser.attributes.given_name;
    const getPenaltyAmount = (invoice: any) => {
        try {
            const links = invoice.subscription_paymentlink || [];
            if (!links.length) return 0;

            const main = links.find((pl: any) => pl.paymentlink_identifier === 0);
            const split1 = links.find((pl: any) => pl.paymentlink_identifier === 1);
            const split2 = links.find((pl: any) => pl.paymentlink_identifier === 2);

            if (links.length === 1) {
                return +main?.penalty_fee || 0;
            }

            return main?.status === 'Complete'
                ? (+main?.penalty_fee || 0)
                : ((+split1?.penalty_fee || 0) + (+split2?.penalty_fee || 0));
        } catch {
            return 0;
        }
    };
    const editInvoiceStatus = (invoice: SubscriptionInvoice) => {
        setEditInvoiceStatFlag(true)
        const normalizedInvoice = {
            ...invoice,
            contract: invoice.subscription_contracts?.contract || {},
            paymentlink: invoice.subscription_paymentlink || [],
            invoiceinformation: null,
            external_invoice_id: invoice.external_invoice_id,
            bucketpath: invoice.bucketpath,
            amount: invoice.amount,
            attempted_charge_date: invoice.attempted_charge_date,
            status: invoice.status,
        };
        setInvoiceToEdit(normalizedInvoice)
        setUpdatedInvoiceStatus(invoice.status)
    }
    const toggleInvoiceEditPopup = () => {
        setEditInvoiceStatFlag(!editInvoiceStatFlag);
    }
    // fetch stuff //////////////////////////////////////////////////////////////
    // invoices
    const [[subscription_invoices, totalSubscriptionInvoicesCount], setSubscriptionInvoices] = React.useState<[[], number]>([[], 0]);
    const [tablepages,settablepages] = useState(0)

    const searchSubscriptionInvoices = async (): Promise<void> => {
        setIsLoading(true);
        const response = await getSubscriptionInvoices();
        setSubscriptionInvoices([response.body, response.totalRecordCount]);
        settablepages(response.totalRecordCount === 0 ? 1 : Math.trunc(response.totalRecordCount / pageState.pageSize) + 1)
        setIsLoading(false);
    }

    // handlers /////////////////////////////////////////////////////////////////
    const handleSearchInputChange = (searchInput: string): void => {
        setTopFormState({
        ...topFormState,
        searchInput: searchInput
        });
    };
    const handleSearchTypeChange = (searchType: TopFormSearchOption): void => {
        setTopFormState({
        ...topFormState,
        searchType: searchType
        });
    };

    const handleTableFetchData = (state: {
        page: number;
        pageSize: number;
        sorted: SortingRule[];
    }): void => {
        setPageState({
            ...pageState,
            page: state.page,
            pageSize: state.pageSize,
            sortingRules: state.sorted,
        });
    };

    const getSubscriptionInvoices = async (paginate: boolean = true, apiInit: any = {}): Promise<any> => {
        const queries: Array<{ name: string; value: string }> = [];
        if (paginate) {
            queries.push({ name: 'limit', value: `${pageState.pageSize}` });
            queries.push({ name: 'offset', value: `${pageState.pageSize * pageState.page}` });
        }
        const selectedDealershipId = Number(topFormState.dealershipId);
        if (Number.isFinite(selectedDealershipId) && selectedDealershipId > 0)
            queries.push({ name: 'contract.dealershipid', value: `${selectedDealershipId}` });
        if (topFormState.searchType.value !== '' && topFormState.searchInput !== '')
            queries.push({
                name: topFormState.searchType.value,
                value: topFormState.searchInput,
            });
        if (filterState.firstName)
            queries.push({ name: 'first-name', value: `${filterState.firstName}` });
        if (filterState.lastName) 
            queries.push({ name: 'last-name', value: `${filterState.lastName}` });
        if (filterState.startDate != null){
            queries.push({ name: "gte-insertedtimestamp", value: filterState.startDate.toISOString() });
        }
        if (filterState.endDate != null){
            queries.push({ name: "lt-insertedtimestamp", value: filterState.endDate.toISOString() });
        }
        // sort
        let i: number = 0;
        for (let sortingRule of pageState.sortingRules)
            queries.push({
                name: `orderBy-${i++}${sortingRule.desc === true ? '-desc' : ''}`,
                value: `${sortingRule.id}`,
            });

        let path: string = '/api/v1/subscription/invoices';
        if (queries.length >= 1) {
            const paramStrings: string[] = queries.map(q => `${encodeURIComponent(q.name)}=${encodeURIComponent(q.value)}`);
            path = `${path}?${paramStrings.join("&")}`;
        }

        try {
            return await API.get(getAPIName(), path, apiInit);
        } catch (e) {
            handleApiErrors(e, enqueueSnackbar);
        }
    };

    const resetPaginationState = (): void => {
        setPageState({
            ...pageState,
            page: 0,
        });
    }

    const handleDealershipSelect = (id: any): void => {
        const selectedDealershipId = typeof id === 'number' && Number.isFinite(id) && id > 0 ? id : 0;
        resetPaginationState();
        setTopFormState({
            ...topFormState,
            dealershipId: selectedDealershipId,
        });
        setFilterSetState(defaultSearchState)
    };

    const handlePaymentLinkReactivation = async (paymentLinkId : string) =>{
        try {
          setIsLoading(true)
          let path = '/api/v1/paymentlink/' + paymentLinkId;
          const response: any = await API.patch(getAPIName(), path,
            {
              body: {"active":"true"}
            });
          handleCustomSnak(`PaymentLink has been reactivated`, 'success')
          setIsLoading(false)
          setreloadData(!reloadData)
        }
        catch (e) {
          handleApiErrors(e, enqueueSnackbar);
          setIsLoading(false)
        }
      }
    const handleStartDateChange = (date?: Date | null): void => {
        setFilterSetState({
            ...filterState,
            startDate: date == null ? undefined : date,
        });
    };
    const handleEndDateChange = (date?: Date | null): void => {
        setFilterSetState({
            ...filterState,
            endDate: date == null ? undefined : date,
        });
    };

    const columns: Column[] = [
        {
            Header: 'Invoice Number',
            accessor: 'id',
            Cell: (props: any) => {
                return props.original.bucketpath && (
                    <a
                        target="_blank"
                        href={
                            'https://tollaid-emailtemplates.s3.us-east-2.amazonaws.com/prod/' +
                            props.original.bucketpath
                        }
                    >
                        {props.original.id}
                    </a>
                )
            }

        },
        {
            Header: 'Invoice Until',
            accessor: 'invoice_date_to',
            Cell: (props: any) => {
                return(
                props.original.invoice_date_to == null ?
                '-'
                : 
                moment(props.original.invoice_date_to).local().format('MM/DD/YYYY h:mm a')
                )
                }
            
        },
        {
            Header: 'First Name',
            accessor: 'subscription_contracts.contract.customer.firstname'
        },
        {
            Header: 'Last Name',
            accessor: 'subscription_contracts.contract.customer.lastname'
        },
        {
            Header: 'Email',
            accessor: 'subscription_contracts.contract.customer.emailaddress',
            Cell: (props: any) => {
                const email = props.original.subscription_contracts?.contract?.customer?.emailaddress;
                const isValid = props.original.subscription_contracts?.contract?.customer?.is_valid;
                const tooltipText = isValid === true ? "Email Validated" : isValid === false ? "Email Undeliverable" : "";
                return email ? (
                    <div style={{ cursor: 'pointer', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    {isValid === false && (
                    <FontAwesomeIcon
                        style={{ color: '#888', marginRight: 3, cursor: 'pointer',marginTop: '3px' }}
                        icon={faExclamationCircle}
                        size="sm"
                    />
                    )}
                    {isValid !== null && isValid !== undefined ? (
                        <Tooltip title={tooltipText}>
                        <span>{email}</span>
                        </Tooltip>
                    ) : (
                        <span>{email}</span>
                    )}
                    </div>
                ) : '-';
            },
            width:180
        },
        {
            Header: 'Amount',
            id: 'amount',
            Cell: (props: any) => {
                return props.original.amount != null ?
                    (
                        props.original.bucketpath && (
                            <a href={'https://tollaid-emailtemplates.s3.us-east-2.amazonaws.com/prod/' + props.original.bucketpath}
                                target="_blank" rel="noopener noreferrer"
                                style={{ backgroundColor: 'lavender', border: '1px solid #e3c8ef', color: 'blue', padding: '5px', fontSize: '12px', textDecoration: 'none', borderRadius: '4px', display: 'inline-block', textAlign: 'center', width: '100%', maxWidth: '100px' }}>
                                ${(+props.original.amount).toFixed(2)}
                            </a>
                        )
                    ) : ('-')
            }
        },
        {
            accessor: (props: any) => `$${getPenaltyAmount(props).toFixed(2)}`,
            Header: 'Penalty Fees',
            id: 'penalty_fees',
            Cell: (props: any) => {
                const penaltyAmount = getPenaltyAmount(props.original);
                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px'
                        }}
                    >
                        <span>${penaltyAmount.toFixed(2)}</span>

                        {
                            (userRole === 'Admin' || userRole === 'Group') && (
                            penaltyAmount > 0 && !['Charged', 'manually_charged'].includes(props.original.status) && (
                            <FontAwesomeIcon
                                icon={faTimesCircle}
                                title="Remove Late Fees"
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    color: '#858585'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#d32f2f';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#858585';
                                }}
                                onClick={() => {
                                    setSelectedInvoiceIdForPenaltyRemoval(props.original.id);
                                    setShowPenaltyRemoveConfirmation(true);
                                }}
                            />
                            )
                        )}
                    </div>
                );
            }
        },       
        {
            Header: 'Status',
            accessor: 'status',
            Cell: (props: any) => {
                return props.original.status ? statusOptionsDict[props.original.status] : '-'
            }
        },
        {
            Header: 'Charge Attempt Date',
            accessor: 'attempted_charge_date',
            Cell: (props: any) => {
                return(
                props.original.attempted_charge_date == null ?
                '-'
                : 
                moment(props.original.attempted_charge_date).local().format('MM/DD/YYYY h:mm a')
                )
                }
            
        },
        {
            Header: 'Dealership',
            accessor: 'subscription_contracts.contract.dealership.name'
        },
        {
            Header: 'PaymentLink',
            accessor: 'subscription_paymentlink.payment_link_url',
            sortable: false,
            Cell: (props: any) => {
                const paymentlinks = props.original.subscription_paymentlink || [];
                const mainLink = paymentlinks.find((pl: any) => pl.paymentlink_identifier === 0);
                if (!mainLink) return "-";
                const status = props.original.status;
                if (statusesThatNeedAttemptedDate.includes(status)) return "-";
                if (mainLink.status === 'Created') {
                    return (
                        <Button
                            onClick={() => window.open(mainLink.payment_link_url)}
                            color="primary" size="small" variant="contained"
                        >
                            Pay
                        </Button>
                    );
                } else if (mainLink.status === 'Expired' && !['partially_charged','Charged'].includes(status)) {
                    return (
                        <Button
                            className={classes.paymentlink_reactivation}
                            onClick={() => handlePaymentLinkReactivation(mainLink.payment_link_id)}
                            color="primary" size="small" variant="contained"
                        >
                            Reactivate
                        </Button>
                    );
                }
                return "-";
            }
        },    
        {
            Header: "Payment Details",
            width: 140,
            Cell: (props: any) => {
                const paymentlinks =
                props.original.subscription_paymentlink ||
                props.original.paymentlink || [];
                const getById = (id: number) => paymentlinks.find((pl: any) => pl.paymentlink_identifier === id);
                // Normal (or subscription) paymentlinks:
                const normal = getById(0);
                const split1 = getById(1);
                const split2 = getById(2);
                // Priority logic:
                let src = null;
                if (normal && normal.status === "Complete") src = normal;
                else if (split1 && split1.status === "Complete" && split2.status !== 'Complete') src = split1;
                else if (split2 && split2.status === "Complete") src = split2;
                else {
                const at =
                    props.original.subscription_contracts.contract && props.original.subscription_contracts.contract.authtoken
                    ? props.original.subscription_contracts.contract.authtoken
                    : null;
                    src = at;
                }
                return (
                <PaymentDetails
                    data={src}
                    logos={PAYMENT_LOGOS}
                    logoSizes={{ 
                        klarna: { width: 38, height: 21 },
                        link: {height:18, width:18}
                    }}
                />
                );
            },
        },
        {
            Header: 'Send Mail',
            width: 80, 
            Cell: (props: any) => {
                const contract = props.original.subscription_contracts?.contract;
                if (!contract) return '-';
                const customer = contract.customer || {};
                const name = `${customer.firstname || ''} ${customer.lastname || ''}`.trim();
                const paymentlink = props.original.subscription_paymentlink?.[0]?.payment_link_url ?? null;
                const paymentlinkid = props.original.subscription_paymentlink?.[0]?.payment_link_id ?? null;
                const mailHref = generateMailHref(
                    props.original.status,
                    name,
                    customer.emailaddress,
                    contract.contractnumber,
                    props.original.bucketpath,
                    contract.dealership.name,
                    true,
                    paymentlink
                );
                if (!mailHref || props.original.subscription_paymentlink.length==0) return '-';
                const handleClick = (e: React.MouseEvent) => {
                    e.preventDefault();
                    if (paymentlinkid && props.original.subscription_paymentlink?.[0]?.status == 'Expired') {
                        handlePaymentLinkReactivation(paymentlinkid);
                    }
                    window.open(mailHref, '_blank');
                };
                return (
                    <a href={mailHref}  onClick={handleClick} target="_blank" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <img
                        src="https://tollaid-emailtemplates.s3.us-east-2.amazonaws.com/DealershipLogos/paperPlaneResized.png"
                        style={{ height: 20, width: 20 }}
                        alt="Send Email"
                    />
                    </a>
                );
            }
        },
        {
            Header: 'Splits',
            accessor: 'subscription_paymentlink.payment_link_url',
            sortable: false,
            Cell: (props: any) => {
                const paymentlinks = props.original.subscription_paymentlink || [];
                const split1 = paymentlinks.find((pl: any) => pl.paymentlink_identifier === 1);
                const split2 = paymentlinks.find((pl: any) => pl.paymentlink_identifier === 2);
                if (split1 && split1.status === 'Created') {
                    return (
                        <Button
                            onClick={() => window.open(split1.payment_link_url)}
                            color="primary" size="small" variant="contained"
                        >
                            Installment 1
                        </Button>
                    );
                }
                if (split2 && split2.status === 'Created' && split1?.status === 'Complete') {
                    return (
                        <Button
                            onClick={() => window.open(split2.payment_link_url)}
                            color="primary" size="small" variant="contained"
                        >
                            Installment 2
                        </Button>
                    );
                }
                return "-";
            }
        },
        {
            Header: 'Edit',
            id: 'edit',
            sortable: false,
            Cell: (props: any) => {
            return (
                < Button
                variant="outlined"
                onClick={() => editInvoiceStatus(props.original)}
                >
                <FontAwesomeIcon icon={faPencilAlt} />
                </Button>
                )
            }
        }
    ]

    const [csvIsLoading, setCsvIsLoading] = useState<boolean>(false);
    // handlers /////////////////////////////////////////////////////////////////
    const handleCsvButton = async (): Promise<void> => {
        setCsvIsLoading(true);
        const response = await getSubscriptionInvoices(false, { headers: { accept: 'text/csv' }, responseType: 'text' });
        // fileDownload(response, 'data.csv');
        const currentDate = moment().format('YYYYMMDD-hhmmss')
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(response);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "SubscriptionInvoiceSummary" + currentDate + fileExtension);
        setCsvIsLoading(false);
    };
    const statusesThatNeedAttemptedDate = ['manually_refunded', 'manually_charged'];
    const updateInvoice = async (invoice: any, updated_status: string): Promise<void> => {
        let apiName = getAPIName();
        let path = `/api/v1/subscription/invoice`;
        try {
        var current_session_data = await Auth.currentAuthenticatedUser();
        var user_name = null
        if (current_session_data.attributes.name || current_session_data.attributes.email) {
            user_name = current_session_data.attributes.name || current_session_data.attributes.email
        }
        const body: Record<string, any> = { 'status': updated_status, 'updated_by': user_name, 'maintain_logs': 'true' }
        if (statusesThatNeedAttemptedDate.includes(updated_status)) {
            body.attempted_charge_date = new Date().toISOString();
        }
        const response = await API.patch(apiName, path + "/" + invoice.id, { body });
        if (response.body[1] > 0) {
            enqueueSnackbar('invoice changes saved!', { variant: 'success' });
        }
        else {
            handleApiErrors("cannot update the status", enqueueSnackbar, 'invoice')
        }
        setUpdateExecuted(!updateExecuted)
        toggleInvoiceEditPopup();
        setInvoiceToEdit({})
        } catch (e) {
        handleApiErrors(e, enqueueSnackbar, 'invoice');
        }
    };
    const handleSaveWithConfirmation = (invoice: any, updated_status: string) => {
    if (statusesThatNeedAttemptedDate.includes(updated_status)) {
        setPendingInvoiceUpdate({ invoice, updated_status });
        setShowConfirmationModal(true);
    } else {
        updateInvoice(invoice, updated_status);
    }
    };

    const handleConfirmationResponse = (confirmed: boolean) => {
    if (confirmed && pendingInvoiceUpdate) {
        updateInvoice(pendingInvoiceUpdate.invoice, pendingInvoiceUpdate.updated_status);
        setEditInvoiceStatFlag(false);
    } 
    else {
        setEditInvoiceStatFlag(true);
    }
    setShowConfirmationModal(false);
    setPendingInvoiceUpdate(null);
    };
    const handleFirstNameInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setFilterSetState({...filterState,firstName: event.target.value});
    };
    const handleLastNameInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setFilterSetState({...filterState,lastName: event.target.value});
    };
    const [selectedInvoiceIdForPenaltyRemoval, setSelectedInvoiceIdForPenaltyRemoval] = useState<number | null>(null);
    const [showPenaltyRemoveConfirmation, setShowPenaltyRemoveConfirmation] = useState(false);    
    const [pnealtyRemovadExecuted,setPnealtyRemovadExecuted] = useState(false)
    const handleConfirmRemovePenalty = async () =>{
        if (!selectedInvoiceIdForPenaltyRemoval) {
            enqueueSnackbar('Failed to select Invoice',  { variant: 'error' });
            return;
        }
        try {      
        setIsLoading(true)
        const response = await API.post(
                getAPIName(),
                `/api/v1/subscription/invoice/remove_penalty/${selectedInvoiceIdForPenaltyRemoval}`,
                {}
            );
        setPnealtyRemovadExecuted(prev => !prev);
        enqueueSnackbar('Late Fees has been removed', { variant: 'success' });
        } catch (err) {
          handleApiErrors(err, enqueueSnackbar);
        }
        finally{
            setIsLoading(false);
            setSelectedInvoiceIdForPenaltyRemoval(null)
            setShowPenaltyRemoveConfirmation(false)
        }
      };

    useEffect(() => { searchSubscriptionInvoices(); }, [pageState, reloadData, updateExecuted, pnealtyRemovadExecuted]);

    // render ///////////////////////////////////////////////////////////////////
    return (
        <div className="SubscriptionInvoices">
            <Grid container>
                <Grid item xs={9}>
                    <Typography variant="h4" align="left">
                        Subscription Invoices
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Button size="small" variant="contained" color="primary" onClick={handleCsvButton}>
                        {!csvIsLoading ? 'Download Excel' :
                            <CircularProgress size={24} />
                        }
                    </Button>
                </Grid>
            </Grid>
            <div className="TopForm">
                <Divider />
                <Grid container spacing={2}>
                    <Grid item sm={3} xs={12}>
                        <AutocompleteSelect
                            apiPath="/dealerships"
                            keySelector="id"
                            valueSelector="name"
                            value={topFormState.dealershipId || undefined}
                            onChange={handleDealershipSelect}
                            placeholder="Select Location"
                            label="Location"
                            flags={{
                              useAPIData: true,
                              enableAutocomplete: true,
                              sortOptions: true,
                            }}
                        />
                    </Grid>
                    <Grid item sm={2} xs={6} >
                        <Typography variant="h3" align={'left'}>
                            <TextField
                                className={classes.textField}
                                onChange={handleFirstNameInputChange}
                                placeholder="First Name"
                                style={{ marginTop: 60, width: '100%' }}
                                value={filterState.firstName}
                            />
                        </Typography>
                    </Grid>
                    <Grid item sm={2} xs={6} >
                        <Typography variant="h3" align={'left'}>
                            <TextField
                                className={classes.textField}
                                onChange={handleLastNameInputChange}
                                placeholder="Last Name"
                                style={{ marginTop: 60, width: '100%' }}
                                value={filterState.lastName}
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={2}> 
                        <TopFormSearch
                            onSearchInputChange={handleSearchInputChange}
                            onSearchTypeChange={handleSearchTypeChange}
                            searchInput={topFormState.searchInput}
                            searchOptions={searchOptions}
                            numericOnlyFields={['id']}
                        />
                    </Grid>
                    <Grid item sm={3} xs={12}>
                        <DateRangePicker
                            endDate={filterState.endDate == null ? null : filterState.endDate}
                            handleEndDateChange={handleEndDateChange}
                            handleStartDateChange={handleStartDateChange}
                            pickTime={true}
                            startDate={filterState.startDate == null ? null : filterState.startDate}
                        />
                    </Grid>
                </Grid>
                
                <Grid item xs={12}>
                    <Button 
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        onClick={searchSubscriptionInvoices}
                    >
                        Search
                    </Button>
                </Grid>

            </div>
            <Grid container style={{marginTop:'20px'}}>
                <Grid xs={12}>
                    <ReactTable
                        className="-striped -highlight"
                        columns={columns}
                        data={subscription_invoices}
                        defaultPageSize={10}
                        defaultSorted={defaultPageState.sortingRules}
                        loading={isLoading}
                        manual
                        onFetchData={handleTableFetchData}
                        pages={tablepages}
                    />
                </Grid>
            </Grid>
            <EditInvoicePopup
                invoice={invoiceToEdit}
                isOpen={editInvoiceStatFlag}
                text="Edit Invoice"
                handleSave={handleSaveWithConfirmation}
                toggleOpen={toggleInvoiceEditPopup}
                updatedInvoiceStatus={updatedInvoiceStatus}
                setUpdatedInvoiceStatus={setUpdatedInvoiceStatus}
                updateExecuted={updateExecuted}
                setUpdateExecuted={setUpdateExecuted}
                customerEdit = {false}
                notesEdit = {false}
                isFromSubscriptionDealer = {true}
            />
            <ConfirmationModal
                open={showConfirmationModal}
                title="Confirm Status Change"
                message="You cannot revert back from this status. Are you sure you want to proceed?"
                onConfirm={() => handleConfirmationResponse(true)}
                onCancel={() => handleConfirmationResponse(false)}
                confirmButtonText="Yes, Proceed"
                cancelButtonText="Cancel"
                showWarningIcon={true}
                confirmButtonColor="#4caf50"
                maxWidth="sm"
            />
            <ConfirmationModal 
                open={showPenaltyRemoveConfirmation} 
                title={`Remove Late Fee for Invoice: ${selectedInvoiceIdForPenaltyRemoval}`}
                message="This action cannot be reverted" 
                confirmButtonText="Yes" 
                cancelButtonText="Cancel" 
                onConfirm={handleConfirmRemovePenalty} 
                onCancel={() => {
                    setShowPenaltyRemoveConfirmation(false);
                    setSelectedInvoiceIdForPenaltyRemoval(null)}
                } 
                showWarningIcon={false} 
                confirmButtonColor="#4caf50" 
                isLoading={isLoading} 
            />
        </div>
    );
}